import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { CollaboratorReportRoutingModule } from './collaborator-report-routing.module';
import { CollaboratorReportComponent } from './collaborator-report.component';
import { ListCollaboratorReportComponent } from './components/list-collaborator-report.component';
import { ExportCollaboratorReportComponent } from './components/export-collaborator-report.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    SharedModule,
    CollaboratorReportRoutingModule
  ],
  declarations: [
    CollaboratorReportComponent,
    ListCollaboratorReportComponent,
    ExportCollaboratorReportComponent
  ]
})
export class CollaboratorReportModule {}
